<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" :model="form" :rules="rules" :isModal="false">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-row :gutter="[24, 8]">
        <a-col :span="24">
          <a-form-item label="头像" name="headShot">
            <img-upload v-model:value="form.headShot" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="姓名" name="name">
            <a-input v-model:value="form.name" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="性别" name="sex">
            <a-select v-model:value="form.sex" :options="sexData" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="手机号" name="phoneNumber">
            <a-input v-model:value="form.phoneNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="出生日期" name="dateBirth">
            <date-picker style="width: 100%" v-model:value="form.dateBirth" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="学历" name="educationBackground">
            <DictSelect v-model:value="form.educationBackground" :dict-name="'education_background'" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工作单位" name="unitWork">
            <a-input v-model:value="form.unitWork" placeholder="请输入工作单位" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="单位类型" name="unitType">
            <DictSelect v-model:value="form.unitType" :dict-name="'businessScope'" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="职称" name="jobTitle">
            <DictSelect v-model:value="form.jobTitle" :dict-name="'talentTitle'" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="专业" name="major">
            <DictSelect v-model:value="form.major" :dict-name="'education_major'" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="研究领域" name="researchArea">
            <DictSelect v-model:value="form.researchArea" :dict-name="'research_field'" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="个人简介" name="personalProfile">
            <a-textarea v-model:value="form.personalProfile" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="科研项目" name="researchProject">
            <a-textarea v-model:value="form.researchProject" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="学术成就" name="academicAchievement">
            <a-textarea v-model:value="form.academicAchievement" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="成就荣誉" name="achievementHonor">
            <a-textarea v-model:value="form.achievementHonor" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="操作案例" name="operationCase">
            <a-textarea v-model:value="form.operationCase" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="擅长领域" name="fieldExpertise">
            <a-textarea v-model:value="form.fieldExpertise" placeholder="请输入" :rows="4" showCount />
          </a-form-item>
        </a-col>
        <!--可编辑区域 end-->
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { technologyManagerInfo } from "@/api/achievementsService";
import DictSelect from "@/components/other/DictSelect";
import DatePicker from "@/components/form/datePicker/DatePicker";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect, DatePicker, },
  mixins: [formMixin],
  data() {
    return {
      sexData: [{ label: '男', value: '0' }, { label: '女', value: '1' }],
      freshGraduateData: [{ label: '是', value: '0' }, { label: '否', value: '1' }],
      education,
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        phoneNumber: [dataCheck.required({}), dataCheck.mobile_phone,],
        name: [dataCheck.required({})],
        dateBirth: [dataCheck.required({})],
        sex: [dataCheck.required({})],
        educationBackground: [dataCheck.required({})],
        major: [dataCheck.required({})],
        researchProject: [],
        unitType: [],
        researchArea: [dataCheck.required({})],
        personalProfile: [],
        jobTitle: [],
        achievementHonor: [],
        academicAchievement: [],
        operationCase: [],
        fieldExpertise: [],
        headShot: [],
        unitWork: [],
        id: [],
      },
      submitUrl: technologyManagerInfo.saveOrUpdate
    }
  },
}
</script>
<style scoped lang="less"></style>
